<ng-template #template>
  <div class="col-lg-4 p-lg-0">
    <div class="card card-comb-left hgs">
      <div class="row no-gutters card-body">
        <div class="col-12" [class.title-aligned]="alignTitleHeight">
          <h2 #title1 style="margin-right: 20px;">{{ data?.part1?.title }}</h2>
          <button
          type="button"
          (click)="zoom(data?.part1?.zoomInfo)"
          class="zoom"
          *ngIf="data?.part1?.zoomInfo"
          [attr.aria-label]="'Zoom ' + data?.part1?.title"
          style="border: none; background: none; padding: 0;"
          ><img src="img/magnifier.svg" width="20px" class="zoom-big-number"
          alt="" aria-hidden="true"
        /></button>
        </div>
        <div class="col-8">
          <span #value1 class="h1-eq" [class.h1-eq-reduced]="reduceSize">{{ data?.part1?.value }}</span>
        </div>
        <div
          class="col-3 text-center"
          *ngIf="data?.part1?.mustDisplayVariation"
        >
          <img
            src="img/arrow-green.svg"
            *ngIf="data?.part1?.trend == '+' && !highContrast"
            [attr.aria-label]="'Improved ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-red.svg"
            *ngIf="data?.part1?.trend == '-' && !highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-equal.svg"
            *ngIf="data?.part1?.trend == '=' && !highContrast"
            [attr.aria-label]="'Stable ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-large-up-red.svg"
            *ngIf="data?.part1?.trend == '+r' && !highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-large-down-green.svg"
            *ngIf="data?.part1?.trend == '-g' && !highContrast"
            [attr.aria-label]="'Improved ' + data?.part1?.title"
            alt=""
          />

          <img
            src="img/arrow-green-hc.svg"
            *ngIf="data?.part1?.trend == '+' && highContrast"
            [attr.aria-label]="'Improved ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-red-hc.svg"
            *ngIf="data?.part1?.trend == '-' && highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-equal-hc.svg"
            *ngIf="data?.part1?.trend == '=' && highContrast"
            [attr.aria-label]="'Stable ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-large-up-red-hc.svg"
            *ngIf="data?.part1?.trend == '+r' && highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part1?.title"
            alt=""
          />
          <img
            src="img/arrow-large-down-green-hc.svg"
            *ngIf="data?.part1?.trend == '-g' && highContrast"
            [attr.aria-label]="'Improved ' + data?.part1?.title"
            alt=""
          />

          <p>{{ data?.part1?.variation }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-4 pl-lg-0">
    <div class="card card-comb-right hgs">
      <div class="row no-gutters card-body">
        <div class="col-12" [class.title-aligned]="alignTitleHeight">
          <h2 #title2 style="margin-right: 20px;">{{ data?.part2?.title }}</h2>
          <button
          type="button"
          (click)="zoom(data?.part2?.zoomInfo)"
          class="zoom"
          *ngIf="data?.part2?.zoomInfo"
          [attr.aria-label]="'Zoom ' + data?.part2?.title"
          style="border: none; background: none; padding: 0;"
          ><img src="img/magnifier.svg" width="20px" class="zoom-big-number"
          alt="" aria-hidden="true"
        /></button>
        </div>
        <div class="col-8">
          <span #value2 class="h1-eq" [class.h1-eq-reduced]="reduceSize">{{ data?.part2?.value }}</span>
        </div>
        <div
          class="col-3 text-center"
          *ngIf="data?.part2?.mustDisplayVariation"
        >
          <img
            src="img/arrow-green.svg"
            *ngIf="data?.part2?.trend == '+' && !highContrast"
            [attr.aria-label]="'Improved ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-red.svg"
            *ngIf="data?.part2?.trend == '-' && !highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-equal.svg"
            *ngIf="data?.part2?.trend == '=' && !highContrast"
            [attr.aria-label]="'Stable ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-large-up-red.svg"
            *ngIf="data?.part2?.trend == '+r' && !highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-large-down-green.svg"
            *ngIf="data?.part2?.trend == '-g' && !highContrast"
            [attr.aria-label]="'Improved ' + data?.part2?.title"
            alt=""
          />

          <img
            src="img/arrow-green-hc.svg"
            *ngIf="data?.part2?.trend == '+' && highContrast"
            [attr.aria-label]="'Improved ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-red-hc.svg"
            *ngIf="data?.part2?.trend == '-' && highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-equal-hc.svg"
            *ngIf="data?.part2?.trend == '=' && highContrast"
            [attr.aria-label]="'Stable ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-large-up-red-hc.svg"
            *ngIf="data?.part2?.trend == '+r' && highContrast"
            [attr.aria-label]="'Disimproved ' + data?.part2?.title"
            alt=""
          />
          <img
            src="img/arrow-large-down-green-hc.svg"
            *ngIf="data?.part2?.trend == '-g' && highContrast"
            [attr.aria-label]="'Improved ' + data?.part2?.title"
            alt=""
          />

          <!--<img src="img/arrow-equal.svg" *ngIf="data?.part2?.trend == '='" triggers="mouseenter:mouseleave"  data-html="true" [ngbPopover]="popContent1" popoverClass="popover-1" placement="right"/> -->
          <p>{{ data?.part2?.variation }}</p>
        </div>
      </div>
    </div>
  </div>
  <ng-template #popContent1
    ><b>Title 1</b><br /><br />Nam dapibus nisl vitae elit fringilla rutrum.
    Aenean sollicitudin, erat a elementum rutrum, neque sem.<br /><br /><a
      href="#"
      role="button"
      class="btn btn-primary"
      >&nbsp;OK&nbsp;</a
    ></ng-template
  >
  <ng-template #popContent2
    ><b>Title 2</b><br /><br />Nam dapibus nisl vitae elit fringilla rutrum.
    Aenean sollicitudin, erat a elementum rutrum, neque sem.<br /><br /><a
      href="#"
      role="button"
      class="btn btn-primary"
      >&nbsp;OK&nbsp;</a
    ></ng-template
  >
</ng-template>
